export const TRANSLATIONS: Record<string, Record<string, string>> = {
  'zh-hans': {
    title: '评 论',
    fediTitle: '联邦宇宙评论',
    loading: 'AI 正在生成评论...',
    empty: '暂无评论。',
    error: '评论加载失败。',
    timeout: '生成超时，请刷新页面。',
    more: '更多',
    emptyContentWarning: '由于无法直接读取页面内容，此条评论由 AI 根据标题生成。',
    poweredBy: '– 由 <a href="https://docs.aigcs.social" target="_blank" rel="noopener">AIGCS</a> 提供支持',
    visitorTitle: '访客评论',
    formName: '昵称',
    formEmail: '邮箱',
    formUrl: '网址',
    formContent: '评论内容',
    formSubmit: '发表评论',
    formReply: '发表回复',
    formSubmitting: '提交中...',
    formSuccess: '评论发表成功！',
    formError: '评论发表失败，请稍后重试。',
    adminPin: '管理员 PIN',
    pinError: 'PIN 错误，请重新输入',
    pinRequired: '管理员邮箱需要验证 管理员 PIN 码',
    delete: '删除',
    deleteConfirm: '确认删除？',
    captchaError: '请完成验证码',
    captchaPrompt: '请完成人机验证后再次提交',
    reply: '回复',
    replyTo: '回复给',
    cancelReply: '取消回复',
    edit: '编辑',
    cancelEdit: '取消',
    edited: '已编辑',
    replyNotify: '有人回复时邮件通知我',
    deleteByEmail: '通过邮箱删除',
    deleteEmailPlaceholder: '输入评论时使用的邮箱',
    sendCode: '发送验证码',
    verifyCode: '验证码',
    verifyDelete: '确认删除',
    codeSent: '验证码已发送，请查收邮件',
    deleteFormError: '删除失败，请重试',
    deleteEmailRequired: '请填写邮箱',
    editTooLate: '超过编辑时限',
    nameTooLong: '昵称太长，请控制在 8 个汉字以内',
    promptPrefix: '提示词：“',
  },
  en: {
    title: 'AI Comments',
    fediTitle: 'Fediverse',
    loading: 'AI is generating comments...',
    empty: 'No comments yet.',
    error: 'Failed to load comments.',
    timeout: 'Generation timed out. Please refresh.',
    more: 'more',
    emptyContentWarning: 'AI generated this comment based on the page title only, as the page content could not be fetched.',
    poweredBy: '– Powered by <a href="https://docs.aigcs.social" target="_blank" rel="noopener">AIGCS</a>',
    visitorTitle: 'Comments',
    formName: 'Name',
    formEmail: 'Email',
    formUrl: 'Website',
    formContent: 'Comment',
    formSubmit: 'Submit Comment',
    formReply: 'Submit Reply',
    formSubmitting: 'Submitting...',
    formSuccess: 'Comment posted successfully!',
    formError: 'Failed to post comment. Please try again.',
    adminPin: 'Admin PIN',
    pinError: 'Incorrect PIN, please try again',
    pinRequired: 'Admin email requires admin PIN verification',
    delete: 'Delete',
    deleteConfirm: 'Confirm delete?',
    captchaError: 'Please complete the captcha',
    captchaPrompt: 'Please complete the verification and submit again',
    reply: 'Reply',
    replyTo: 'Reply to',
    cancelReply: 'Cancel reply',
    edit: 'Edit',
    cancelEdit: 'Cancel',
    edited: 'Edited',
    replyNotify: 'Notify me by email when someone replies',
    deleteByEmail: 'Delete via email',
    deleteEmailPlaceholder: 'Enter your comment email',
    sendCode: 'Send Code',
    verifyCode: 'Verification Code',
    verifyDelete: 'Confirm Delete',
    codeSent: 'Code sent, please check your email',
    deleteFormError: 'Delete failed, please try again.',
    deleteEmailRequired: 'Please enter your email',
    editTooLate: 'Edit window expired',
    nameTooLong: 'Name is too long. Please use at most 8 CJK characters (16 latin letters).',
    promptPrefix: 'Prompt: "',
  },
  'zh-hant': {
    title: 'AI 評論',
    loading: 'AI 正在產生評論...',
    empty: '暫無評論。',
    error: '評論載入失敗。',
    timeout: '產生超時，請重新整理頁面。',
    more: '更多',
    emptyContentWarning: '由於無法直接讀取頁面內容，此條評論由 AI 根據標題產生。',
    poweredBy: '– 由 <a href="https://docs.aigcs.social" target="_blank" rel="noopener">AIGCS</a> 提供支援',
    visitorTitle: '訪客評論',
    formName: '暱稱',
    formEmail: '郵箱',
    formUrl: '網址',
    formContent: '評論內容',
    formSubmit: '發表評論',
    formReply: '發表回覆',
    formSubmitting: '提交中...',
    formSuccess: '評論發表成功！',
    formError: '評論發表失敗，請稍後重試。',
    adminPin: '管理員 PIN',
    pinError: 'PIN 錯誤，請重新輸入',
    pinRequired: '管理員郵箱需要驗證管理員 PIN 碼',
    delete: '刪除',
    deleteConfirm: '確認刪除？',
    captchaError: '請完成驗證碼',
    captchaPrompt: '請完成人機驗證後再次提交',
    reply: '回覆',
    replyTo: '回覆給',
    cancelReply: '取消回覆',
    edit: '編輯',
    cancelEdit: '取消',
    edited: '已編輯',
    replyNotify: '有人回覆時郵件通知我',
    deleteByEmail: '透過郵箱刪除',
    deleteEmailPlaceholder: '輸入評論時使用的郵箱',
    sendCode: '發送驗證碼',
    verifyCode: '驗證碼',
    verifyDelete: '確認刪除',
    codeSent: '驗證碼已發送，請查收郵件',
    deleteFormError: '刪除失敗，請重試',
    deleteEmailRequired: '請填寫郵箱',
    editTooLate: '超過編輯時限',
    nameTooLong: '暱稱太長，請控制在 8 個漢字以內',
    promptPrefix: '提示詞：“',
  },
}
